export default __webpack_public_path__ + "static/media/icon_13.0a791963.png";